import { render } from "./chaxun.vue?vue&type=template&id=5230f7b0&scoped=true"
import script from "./chaxun.vue?vue&type=script&lang=js"
export * from "./chaxun.vue?vue&type=script&lang=js"

import "./chaxun.vue?vue&type=style&index=0&id=5230f7b0&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5230f7b0"]])

export default __exports__